import { NodeData } from "../types/node-data.types";

/** The greeting a step falls back to when its message is still empty. */
export const DEFAULT_MESSAGE_SIGNATURE = "Hi {prospect_firstName|Prospect First Name},\n";

/**
 * The editor's message for the current mode, falling back to the default greeting. Extracted from
 * `CampaignPage.tsx`, which is over the file-length ratchet and may only shrink.
 */
export const resolveMessageSignature = (
	node: { data?: NodeData } | null | undefined,
	eventBasedState: boolean
): string =>
	(eventBasedState ? node?.data?.alternateMessage : node?.data?.message) ||
	DEFAULT_MESSAGE_SIGNATURE;
